<template>
  <transition name="video-fade" :appear="appear">
    <div class="video-container">
      <div v-show="loading" class="video-loader js-video-loader">
        <IconLoaderVideo/>
      </div>
      <div class="video-wrap">
        <!-- Close button -->
        <div class="video-close" @click="handleClose">
          <svg width="19" height="19" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31.11 31.11">
            <path fill="#fff" d="M31.11 1.41L29.7 0 15.56 14.14 1.41 0 0 1.41l14.14 14.15L0 29.7l1.41 1.41 14.15-14.14L29.7 31.11l1.41-1.41-14.14-14.14L31.11 1.41z"/>
          </svg>
        </div>
        <!-- Video container -->
        <video
          playsinline
          preload="auto"
          ref="video"
          class="video-player"
          :src="url"
          @click="playPauseVideo">
        </video>
        <!-- Video loader -->
        <!-- Video controls -->
        <video-controls
          v-bind="{play,pause, position, duration, muted}"
          @state="playPauseVideo"
          @mute="muteVideo"
          @fullscreen="fullscreenVideo"
          @seek="video.currentTime = $event">
        </video-controls>
      </div>
    </div>
  </transition>
</template>

<script>
  import IconLoaderVideo from "../../icons/icon-loader-video"
  import VideoControls from './VideoControls'
  import screenfull from 'screenfull'
  import gsap from "gsap"
import Utils from '../../../utils/utils'

  export default {
    props: {
      url: {
        type: String,
        default: ''
      },
      handleClose: {
        type: Function,
        required: true
      },
      appear: {
        type: Boolean
      }
    },
    components: {VideoControls, IconLoaderVideo},
    data() {
      return {
        player: null,
        firstLaunch: true,
        autoplayHasFailed: false,

        isSafari: Utils.isSafari(),
        isMobile: false,
        video: null,

        // States
        loading: false,
        play: false,
        pause: true,

        // Sound
        muted: false,

        // Video progress
        position: 0,
        duration: 0,

        // hide controls
        hideControls: false,
        moveDelay: 2000,
        moveTimeout: null
      }
    },
    methods: {

      removeAllEvents(){

        document.removeEventListener('keyup', this.handleKeyEsc, true)

        // Pause/play video on Space
        document.removeEventListener('keyup', this.handleKeySpace, true)

        // Fullscreen on F
        document.removeEventListener('keyup', this.handleKeyF, true)

        // Get duration
        this.$refs.video.removeEventListener('loadedmetadata', this.onLoadedMetadata)

        // Calculate the seek bar value
        this.$refs.video.removeEventListener("timeupdate", this.onTimeUpdate)
      },

      onLoadedMetadata: function(){
        this.duration = this.$refs.video.duration
      },

      onTimeUpdate: function(){
          this.position = (100 / this.duration) * this.$refs.video.currentTime
      },


      handleKeySpace(evt){
        (evt.keyCode === 27 || evt.which === 27) ? this.handleClose() : null
      },

      handleKeyEsc(evt){
        (evt.keyCode === 32 || evt.which === 32) ? this.playPauseVideo() : null
      },

      handleKeyF(evt){
        (evt.keyCode === 70 || evt.which === 70) ? this.fullscreenVideo() : null
      },

      /**
       * Init video
       * Change states between play and pause
       */
      playPauseVideo() {

        console.log("playPauseVideo", this.$refs.video.paused, !this.play)

        if (this.$refs.video.paused || !this.play) {

          // user trigger play after autoplay has failed
          if(this.autoplayHasFailed){
            this.autoplayHasFailed = false
            this.loading = true
          }

          console.log("will play")

          this.playVideo()
        } 
        else {
          this.loading = false
          console.log("will pause")
          this.pauseVideo()
        }
      },
      playVideo(){
        this.play = true
        this.pause = false
        this.$refs.video.play()
      },
      pauseVideo() {
        this.play = false
        this.pause = true
        this.$refs.video.pause()
      },
      /**
       * Mute video
       * Detect state, make reversed
       * Store in localStorage
       */
      muteVideo() {
        const state = !this.muted
        this.muted = state
        this.$refs.video.muted = state

        // Save to localStorage
        localStorage.muted = state
      },
      /**
       * Show video in fullscreen
       */
      fullscreenVideo() {
        //if (screenfull.enabled) {
          screenfull.toggle(this.$refs.video)
        //}
      },
      /**
       * Hide controls after delay
       */
      hideVideoControls() {
        this.hideControls = false
        if (this.moveTimeout) clearTimeout(this.moveTimeout)
        this.moveTimeout = setTimeout(() => this.hideControls = true, this.moveDelay)
      }
    },
    beforeDestroy(){
      this.$refs.video.pause()
      this.$refs.video.remove()
      this.removeAllEvents()
      this.$refs.video = null

    },

    watch: {
      loading: function(nextState){
        console.log("watching LOADING", nextState)

        if(nextState){
          this.loadingTl.restart()
        } else {
          this.loadingTl.pause()
        }
      }
    },

    mounted() {

      this.loadingTl = gsap.timeline({
        paused: true
      })
      .to(".icon__loader-video", {
        ease: "power2.inOut",
        duration: 1.5,
        repeat: -1,
        repeatDelay: 1,
        rotate: 360
      })


      this.video = this.$refs.video

      const isMobileSafari = Utils.isSafari() && this.$root.mobileDetected


      this.$refs.video.addEventListener("suspend", () => {
        console.log("suspend")
      })

      // Get duration
      this.$refs.video.addEventListener('loadedmetadata', this.onLoadedMetadata)

      // Calculate the seek bar value
      this.$refs.video.addEventListener("timeupdate", this.onTimeUpdate)

      let onCanPlay = (message) => {

        window.addConsole(`--> onCanPlay`)

        console.log("onCanPlay > message", message)

        if(isMobileSafari){
          this.firstLaunch = false

          console.log("played")
          this.loading = false
          this.play = true
          this.pause = false

        } else {
          this.firstLaunch = false

          this.$refs.video.play()
            .then(() => {
              console.log("played")
              this.loading = false
              this.play = true
              this.pause = false
            })
            .catch(err => {
              console.log("err", err)
              this.loading = false
              this.autoplayHasFailed = true
            })
        }
          
      }

      // this.$refs.video.addEventListener("canplay", () => onCanPlay("canplay"), {once: true})
      this.$refs.video.addEventListener("canplaythrough", () => onCanPlay("canplaythrough"), {once: true})
      this.$refs.video.addEventListener("playing", () => {
        console.log("message", "playing but paused = ", this.$refs.video.paused)

        if(!this.firstLaunch){
          this.loading = false
        }
      })

      this.$refs.video.addEventListener("waiting", () => {
        console.log("waiting")
        if(!isMobileSafari || !this.firstLaunch){
          console.log('waiting => loading = true')
          this.loading = true


          this.$refs.video.addEventListener("canplay", () => {
            this.loading = false
          }, {once: true})
        }
        
      })

      this.$refs.video.addEventListener("stalled", () => {
        console.log("stalled", this.video.paused)

        if((!isMobileSafari && !this.video.paused) || (isMobileSafari && !this.firstLaunch)){
          console.log('stalled => loading = true')
          this.loading = true
        }

      })

      this.$refs.video.addEventListener("loadeddata", () => {
        console.log("loadeddata")
      })

      // Hide video when ended
      // Reset position for seek bar
      this.$refs.video.addEventListener("ended", () => {
        this.play = false
        this.pause = true
      });
      

      // Add loading events
      // Control loader visibility
      this.$refs.video.addEventListener("loadstart", () => {
        console.log("event loadstart")
        window.addConsole(`--> loadstart`)

        if((!isMobileSafari && !Utils.isInstagram()) || !this.firstLaunch){
          console.log('loadstart => loading = true')
          this.loading = true
        }
      })
      this.$refs.video.addEventListener("seeking", () => {
        console.log("seeking")
        this.loading = true
      })

      this.$refs.video.addEventListener("seeked", () => {
        console.log("seeked")
        this.loading = false
      })

      // Video ended
      this.$refs.video.addEventListener('ended', () => this.handleClose(), false)

      // show controls if mouse move
      document.addEventListener('mousemove', () => this.hideVideoControls(), false)


      // Keyboard events
      // Close video on ESC
      document.addEventListener('keyup', this.handleKeyEsc, true)

      // Pause/play video on Space
      document.addEventListener('keyup', this.handleKeySpace, true)

      // Fullscreen on F
      document.addEventListener('keyup', this.handleKeyF, true)

      if(isMobileSafari){
        console.log("fucked it play")
        this.loading = true

        this.$refs.video.play()
          .then(() => {
            console.log("success play")
          })
          .catch(err => {
            console.log("failed play", err)
            this.autoplayHasFailed = true
            this.loading = false
          })
      }


    },
  }
</script>

<style scoped lang="sass">
.video-container
  height: 100%
  position: fixed
  top: 0
  left: 0
  right: 0
  bottom: 0
  z-index: 400
  background: black      

  .video-loader
    z-index: 1
    width: 200px
    position: absolute
    left: 50%
    top: 50%
    transform: translate(-50%, -50%)

    .icon__loader-video
      fill: #fff

  .video-wrap
    width: 100%
    height: 100%
    position: absolute
    background: black
    transition: opacity .8s ease 1s
    .video-close
      color: white
      position: absolute
      top: 0
      right: 0
      font-size: 1.375rem
      padding: 2.5rem
      cursor: pointer
      z-index: 100
    video
      width: 100%
      height: 100%
      z-index: 5
      cursor: pointer
    .video-loader
      position: absolute
      top: 0
      bottom: 0
      left: 0
      right: 0
      margin: auto
      height: 2em
      width: 2em
      opacity: 0
      transition: opacity .4s
      z-index: 10
      &.loading
        opacity: 1
.video-fade
  &-enter-active
    transition: opacity .8s
  &-leave-active
    transition: opacity .4s .4s
    ::v-deep.video-wrap
      transition: opacity .4s
  &-enter, &-leave-to
    opacity: 0
    ::v-deep.video-wrap
      opacity: 0
  &-enter-to, &-leave
    opacity: 1
    ::v-deep.video-wrap
      opacity: 1
</style>
